import { render } from "./ArticleTOC.vue?vue&type=template&id=d63279a6&scoped=true"
import script from "./ArticleTOC.vue?vue&type=script&lang=js"
export * from "./ArticleTOC.vue?vue&type=script&lang=js"

import "./ArticleTOC.vue?vue&type=style&index=0&id=d63279a6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/gs-webex-sys/gs-webex-sys/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d63279a6"]])

export default __exports__